
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 15 15","fill":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.48 1.434L11.637.777c-.301-.082-.63.082-.766.383L9.56 4.223a.677.677 0 00.191.765l1.668 1.367a10.264 10.264 0 01-4.84 4.84L5.211 9.527a.677.677 0 00-.766-.191l-3.062 1.312a.698.698 0 00-.383.766l.656 2.844a.65.65 0 00.657.492C9.313 14.75 15 9.09 15 2.062c0-.3-.219-.546-.52-.628z"}})])
          )
        }
      }
    